import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "chat-header-agent-name" }
const _hoisted_2 = {
  key: 0,
  class: "ml-1 text-body-2 chat-header-title"
}
const _hoisted_3 = { class: "text-caption text-medium-emphasis ml-3 chat-header-description" }
const _hoisted_4 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_5 = {
  key: 4,
  class: "token-usage-display mt-2"
}
const _hoisted_6 = { class: "token-usage-value" }
const _hoisted_7 = { class: "message-copy-menu" }
const _hoisted_8 = { class: "message-email-button" }
const _hoisted_9 = {
  key: 5,
  class: "message-download-button"
}
const _hoisted_10 = {
  key: 6,
  class: "message-regenerate-button"
}
const _hoisted_11 = {
  key: 7,
  class: "message-retry-button"
}
const _hoisted_12 = {
  key: 8,
  class: "message-generating"
}
const _hoisted_13 = {
  key: 0,
  class: "chat-copy-menu"
}
const _hoisted_14 = {
  class: "chat-input-area flex-shrink-0",
  ref: "chatInputArea"
}
const _hoisted_15 = {
  key: 0,
  class: "stream-stop-wrapper mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_AgentShareDialog = _resolveComponent("AgentShareDialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ToolEventsPanel = _resolveComponent("ToolEventsPanel")!
  const _component_FormattingCard = _resolveComponent("FormattingCard")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_StreamingAudioPlayer = _resolveComponent("StreamingAudioPlayer")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_CandlestickChart = _resolveComponent("CandlestickChart")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ImageUploadManager = _resolveComponent("ImageUploadManager")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "chat-wrapper pa-0 d-flex flex-column" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "d-flex flex-column w-100 chat-card",
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline flex-shrink-0 d-flex align-center py-0" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "agent-selector", {}, () => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.agent.name), 1)
              ], true),
              (_ctx.session.title && _ctx.session.title !== 'New Chat')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "  " + _toDisplayString(_ctx.session.title), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.agent.description), 1),
              (_ctx.username === _ctx.ownerUsername)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 1,
                    text: "Share this agent",
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        icon: "mdi-share-variant",
                        size: "small",
                        variant: "text",
                        color: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showShare = true))
                      }), null, 16)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_AgentShareDialog, {
                modelValue: _ctx.showShare,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showShare) = $event)),
                ownerUsername: _ctx.ownerUsername,
                slug: _ctx.agentSlug,
                agentName: _ctx.agent.name
              }, null, 8, ["modelValue", "ownerUsername", "slug", "agentName"])
            ]),
            _: 3
          }),
          _createVNode(_component_v_divider, { class: "flex-shrink-0" }),
          _createVNode(_component_v_card_text, {
            class: "chat-area flex-grow-1",
            ref: "chatArea"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayMessages, ({ message, sourceIndex }, displayIndex) => {
                return (_openBlock(), _createBlock(_component_v_row, {
                  key: `${_ctx.session.id}-${sourceIndex}`,
                  ref_for: true,
                  ref: (el) => { if (el) _ctx.messageElements[displayIndex] = el as any },
                  justify: message.role === 'user' ? 'end' : 'start',
                  "no-gutters": "",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "10",
                      md: "9",
                      lg: "9"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["message-name text-caption mb-1", message.role === 'user' ? 'text-right' : 'text-left'])
                        }, _toDisplayString(message.role === 'user' ? (_ctx.username || 'You') : _ctx.agent.name), 3),
                        _createElementVNode("div", {
                          class: _normalizeClass(["message-container", [
                message.role === 'user' ? 'user-message pb-6' : 'assistant-message'
              ]])
                        }, [
                          (message.role === 'assistant')
                            ? (_openBlock(), _createBlock(_component_ToolEventsPanel, {
                                key: 0,
                                "tool-events": message.toolEvents || [],
                                "show-activity": _ctx.shouldShowToolActivity(message, sourceIndex)
                              }, null, 8, ["tool-events", "show-activity"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_FormattingCard, {
                            content: message.content,
                            expanded: true,
                            title: null,
                            streaming: _ctx.streamingMessageIndex === sourceIndex,
                            class: "text-wrap text-break"
                          }, null, 8, ["content", "streaming"]),
                          (_ctx.isRefusedMessage(message))
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 1,
                                type: "warning",
                                variant: "tonal",
                                density: "compact",
                                icon: "mdi-shield-alert-outline",
                                class: "refusal-notice mt-2"
                              }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                  _createElementVNode("div", { class: "text-body-2 font-weight-medium" }, "The model declined to continue this response.", -1),
                                  _createElementVNode("div", { class: "text-caption" }, "Rephrasing the request may help.", -1)
                                ])),
                                _: 1,
                                __: [7]
                              }))
                            : _createCommentVNode("", true),
                          (message.role === 'assistant' && _ctx.agent.hasVoice)
                            ? (_openBlock(), _createBlock(_component_StreamingAudioPlayer, {
                                key: 2,
                                ref_for: true,
                                ref: (el) => _ctx.setStreamingPlayerRef(sourceIndex, el),
                                "auto-play": true,
                                "mime-type": "audio/webm; codecs=opus",
                                "canv-height": 40,
                                "fft-size": 512,
                                class: "message-player"
                              }, null, 512))
                            : _createCommentVNode("", true),
                          (_ctx.hasFinancialChart(message))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_expansion_panels, {
                                  variant: "inset",
                                  density: "compact",
                                  multiple: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllFinancialChartData(message), (chartItem) => {
                                      return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                        key: `chart-${message.role}-${sourceIndex}-${chartItem.index}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panel_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.getChartTitle(chartItem.data)), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_expansion_panel_text, { class: "pa-0" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_CandlestickChart, {
                                                chartData: chartItem.data,
                                                width: _ctx.getChartDimensions().width,
                                                height: _ctx.getChartDimensions().height,
                                                "show-volume": true,
                                                "enable-zoom": true,
                                                "show-tooltip": true
                                              }, null, 8, ["chartData", "width", "height"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (message.role === 'assistant' && message.tokenUsage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "token-usage-label" }, "Tokens: ", -1)),
                                _createElementVNode("span", _hoisted_6, " Prompt: " + _toDisplayString(message.tokenUsage.promptTokens) + " | Completion: " + _toDisplayString(message.tokenUsage.completionTokens) + " | Total: " + _toDisplayString(message.tokenUsage.totalTokens), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_v_menu, { location: "bottom" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                                  icon: "mdi-dots-horizontal",
                                  size: "small",
                                  variant: "text",
                                  color: "primary"
                                }), null, 16)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, { density: "compact" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item, {
                                      onClick: ($event: any) => (_ctx.copyMessageMarkdown(message))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                                            _createTextVNode("Copy Markdown")
                                          ])),
                                          _: 1,
                                          __: [9]
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_v_list_item, {
                                      onClick: ($event: any) => (_ctx.copyMessageText(message))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode("Copy Text")
                                          ])),
                                          _: 1,
                                          __: [10]
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    (message.toolEvents && message.toolEvents.length > 0)
                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.copyMessageToolEvents(message))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                _createTextVNode("Copy Tool Events")
                                              ])),
                                              _: 1,
                                              __: [11]
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_list_item, {
                                      onClick: ($event: any) => (_ctx.copyMessageAll(message))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode("Copy All")
                                          ])),
                                          _: 1,
                                          __: [12]
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_v_tooltip, {
                              text: "Email Message",
                              location: "top"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                                  icon: "mdi-email-fast-outline",
                                  size: "small",
                                  variant: "text",
                                  color: "primary",
                                  onClick: ($event: any) => (_ctx.emailMessage(message)),
                                  disabled: _ctx.loading
                                }), null, 16, ["onClick", "disabled"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          (message.role === 'assistant' && _ctx.agent.hasVoice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_v_tooltip, {
                                  text: "Download Audio",
                                  location: "top"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                                      icon: "mdi-download",
                                      size: "small",
                                      variant: "text",
                                      color: "primary",
                                      disabled: _ctx.loading,
                                      onClick: ($event: any) => (_ctx.downloadAudio(sourceIndex))
                                    }), null, 16, ["disabled", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (message.role === 'assistant' && _ctx.agent.hasVoice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_v_tooltip, {
                                  text: "Regenerate Audio",
                                  location: "top"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                                      icon: "mdi-reload",
                                      size: "small",
                                      variant: "text",
                                      color: "primary",
                                      disabled: _ctx.loading,
                                      onClick: ($event: any) => (_ctx.regenerateAudio(sourceIndex))
                                    }), null, 16, ["disabled", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (message.role === 'assistant' && _ctx.shouldShowRetryButton(message, sourceIndex))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_v_tooltip, {
                                  text: "Retry Response",
                                  location: "top"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                                      icon: "mdi-refresh",
                                      size: "small",
                                      variant: "text",
                                      color: "primary",
                                      loading: message.retryState?.autoRetryPending === true,
                                      disabled: _ctx.loading,
                                      onClick: ($event: any) => (_ctx.retryFailedAssistantResponse(sourceIndex, 'manual'))
                                    }), null, 16, ["loading", "disabled", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            : _createCommentVNode("", true),
                          (message.role === 'assistant' && sourceIndex === _ctx.streamingMessageIndex && _ctx.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_v_progress_circular, {
                                  size: "small",
                                  color: "primary",
                                  indeterminate: "",
                                  class: "mr-2"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["justify"]))
              }), 128)),
              (_ctx.localMessages.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_v_tooltip, {
                      text: "Email Conversation",
                      location: "top"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          icon: "mdi-email-fast-outline",
                          size: "small",
                          variant: "text",
                          color: "primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emailAllMessages())),
                          disabled: _ctx.loading,
                          class: "mr-2"
                        }), null, 16, ["disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_menu, { location: "top" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          icon: "mdi-dots-horizontal",
                          size: "small",
                          variant: "text",
                          color: "primary"
                        }), null, 16)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyAllResponsesMarkdown()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode("Copy All Responses as Markdown")
                                  ])),
                                  _: 1,
                                  __: [13]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyAllResponsesWithToolEvents()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createTextVNode("Copy All Responses and Tool Events")
                                  ])),
                                  _: 1,
                                  __: [14]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyAllMessagesWithToolEvents()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                    _createTextVNode("Copy All Messages and Tool Events")
                                  ])),
                                  _: 1,
                                  __: [15]
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512),
          (_ctx.showScrollToBottomBtn)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "scroll-to-bottom-fab",
                icon: "",
                size: "small",
                color: "primary",
                elevation: "4",
                onClick: _ctx.resumeAutoScroll
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-chevron-down")
                    ])),
                    _: 1,
                    __: [16]
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_divider),
            _createVNode(_component_ImageUploadManager, {
              ref: "imageUploadManager",
              disabled: _ctx.loading,
              "max-images": 5,
              onImagesChanged: _ctx.handleImagesChanged,
              onError: _ctx.handleImageError,
              class: "px-2 pt-2"
            }, null, 8, ["disabled", "onImagesChanged", "onError"]),
            _createVNode(_component_v_row, { class: "pa-2 pt-0 ma-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "pa-0 ma-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.prompt,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.prompt) = $event)),
                      label: "Ask a question...",
                      rows: "1",
                      "max-rows": "6",
                      "auto-grow": "",
                      variant: "outlined",
                      class: "chat-input",
                      "hide-details": "",
                      onKeydown: _withKeys(_ctx.handleEnter, ["enter"]),
                      onPaste: _ctx.handlePaste,
                      readonly: _ctx.loading
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_Button, {
                          color: "primary",
                          click: _ctx.selectImages,
                          icon: "mdi-image-plus",
                          size: "large",
                          tooltip: "Add images",
                          disabled: _ctx.loading
                        }, null, 8, ["click", "disabled"])
                      ]),
                      append: _withCtx(() => [
                        (_ctx.isStreaming)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_v_progress_circular, {
                                color: "primary",
                                indeterminate: "",
                                size: "32",
                                width: "3"
                              }),
                              _createVNode(_component_v_btn, {
                                class: "stream-stop-btn",
                                color: "primary",
                                icon: "",
                                size: "small",
                                variant: "plain",
                                onClick: _ctx.stopStreamingChat
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                      _createTextVNode("mdi-stop")
                                    ])),
                                    _: 1,
                                    __: [17]
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]))
                          : (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 1,
                                color: "primary",
                                indeterminate: "",
                                class: "mr-2"
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 2,
                                color: "primary",
                                click: _ctx.sendMessage,
                                icon: "mdi-send",
                                size: "x-large",
                                tooltip: "Send",
                                disabled: _ctx.loading || !_ctx.prompt.trim()
                              }, null, 8, ["click", "disabled"]))
                      ]),
                      "append-inner": _withCtx(() => [
                        (_ctx.voice.state === 'loading-model' || _ctx.voice.state === 'transcribing')
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              color: "primary",
                              indeterminate: "",
                              size: "24",
                              width: "2"
                            }))
                          : (_ctx.voice.supported)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                color: _ctx.voice.state === 'recording' ? 'error' : 'primary',
                                click: _ctx.startVoiceInput,
                                icon: _ctx.voice.state === 'recording' ? 'mdi-stop' : 'mdi-microphone',
                                size: "large",
                                tooltip: _ctx.voiceTooltip,
                                disabled: _ctx.loading
                              }, null, 8, ["color", "click", "icon", "tooltip", "disabled"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onKeydown", "onPaste", "readonly"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 512)
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}